import script from "./MyProfile.vue?vue&type=script&lang=ts&setup=true"
export * from "./MyProfile.vue?vue&type=script&lang=ts&setup=true"

import "./MyProfile.vue?vue&type=style&index=0&id=0c3e5bd8&lang=css"

const __exports__ = script;

export default __exports__